import y from "../../../../public/projects/vilasjavdekar/projects/y.jpg";
import s from "../../../../public/projects/vilasjavdekar/logo/s.png";
import evergreen from "../../../../public/projects/vilasjavdekar/projects/ev.jpg"

// portiagrande
import overviewImageportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/overview/1.webp";
import bannerDesktopImageportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/banner/1.webp";
import bannerMobileImageportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/banner/2.webp";
import Locationportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/location/1.webp";
import Hightlightsportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/highlights/1.webp";
import floorplan1portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/floorplan/1.webp";
import floorplan2portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/floorplan/2.webp";
import floorplan3portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/floorplan/3.webp";
import floorplan4portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/floorplan/4.webp";
import floorplan5portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/floorplan/5.webp";
import locationiconportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/overview/l.png";
import caliconportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/overview/c.png";
import newlaunchiconportiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/overview/n.png";
import gallery1portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/gallery/1.webp";
import gallery2portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/gallery/2.webp";
import gallery3portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/gallery/3.webp";
import gallery4portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/gallery/4.webp";
import gallery5portiagrande from "../../../../public/projects/vilasjavdekar/portiagrande/gallery/5.webp";

// projecttwo
import overviewImageprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/overview/1.webp";
import bannerDesktopImageprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/banner/1.webp";
import bannerMobileImageprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/banner/2.webp";
import Locationprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/location/1.webp";
import Hightlightsprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/highlights/1.webp";
import floorplan1projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/floorplan/1.webp";
import floorplan2projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/floorplan/2.webp";
import floorplan3projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/floorplan/3.webp";
import floorplan4projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/floorplan/4.webp";
import floorplan5projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/floorplan/5.webp";
import locationiconprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/overview/l.png";
import caliconprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/overview/c.png";
import newlaunchiconprojecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/overview/n.png";
import gallery1projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/gallery/1.webp";
import gallery2projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/gallery/2.webp";
import gallery3projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/gallery/3.webp";
import gallery4projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/gallery/4.webp";
import gallery5projecttwo from "../../../../public/projects/vilasjavdekar/projecttwo/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/vilasjavdekar/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/vilasjavdekar/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/vilasjavdekar/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/vilasjavdekar/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/vilasjavdekar/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/vilasjavdekar/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/vilasjavdekar/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/vilasjavdekar/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/vilasjavdekar/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/vilasjavdekar/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/vilasjavdekar/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/vilasjavdekar/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/vilasjavdekar/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/vilasjavdekar/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/vilasjavdekar/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/vilasjavdekar/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/vilasjavdekar/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/vilasjavdekar/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/vilasjavdekar/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/vilasjavdekar/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/vilasjavdekar/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/vilasjavdekar/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/vilasjavdekar/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/vilasjavdekar/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/vilasjavdekar/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/vilasjavdekar/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/vilasjavdekar/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/vilasjavdekar/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/vilasjavdekar/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/vilasjavdekar/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/vilasjavdekar/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/vilasjavdekar/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/vilasjavdekar/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/vilasjavdekar/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/vilasjavdekar/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/vilasjavdekar/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/vilasjavdekar/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/vilasjavdekar/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/vilasjavdekar/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/vilasjavdekar/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/vilasjavdekar/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/vilasjavdekar/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/vilasjavdekar/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/vilasjavdekar/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/vilasjavdekar/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/vilasjavdekar/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/vilasjavdekar/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/vilasjavdekar/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/vilasjavdekar/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/vilasjavdekar/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/vilasjavdekar/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/vilasjavdekar/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/vilasjavdekar/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/vilasjavdekar/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/vilasjavdekar/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/vilasjavdekar/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/vilasjavdekar/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/vilasjavdekar/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/vilasjavdekar/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/vilasjavdekar/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/vilasjavdekar/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/vilasjavdekar/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/vilasjavdekar/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/vilasjavdekar/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/vilasjavdekar/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/vilasjavdekar/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/vilasjavdekar/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/vilasjavdekar/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/vilasjavdekar/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/vilasjavdekar/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/vilasjavdekar/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/vilasjavdekar/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/vilasjavdekar/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/vilasjavdekar/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/vilasjavdekar/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/vilasjavdekar/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/vilasjavdekar/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/vilasjavdekar/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/vilasjavdekar/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/vilasjavdekar/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/vilasjavdekar/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/vilasjavdekar/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/vilasjavdekar/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/vilasjavdekar/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/vilasjavdekar/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/vilasjavdekar/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/vilasjavdekar/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/vilasjavdekar/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/vilasjavdekar/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/vilasjavdekar/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/vilasjavdekar/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/vilasjavdekar/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/vilasjavdekar/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/vilasjavdekar/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/vilasjavdekar/projectten/gallery/5.webp";



export const developervilasjavdekar = {
  properties: [
    {
      name: "vilasjavdekar The Trillion",
      image: bannerMobileImageportiagrande,
      price: " 6.14 Crore Onwards",
      state: " Gurugram",
      developer: "vilasjavdekar",
      location: "Sector 48, Gurugram",
      projectlocation: "Gurugram",
      bed: "3,4 BHK Apartments",
      size: "3000-3600 sq.ft.",
      url: `/vilasjavdekar-trillion`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "vilasjavdekar The Trillion",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "2006",
  },
  about: `vilasjavdekar, a 100% FDI funded real-estate developer, backed by vilasjavdekar Holdings Pte. Ltd., Singapore, the real estate investing division of the AT Holdings group of companies. AT Capital, headquartered in Singapore, was established with the aim of capitalizing on global opportunities within both established and emerging sectors.`,
};


export const projectsvilasjavdekar = {

  portiagrande: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageportiagrande,
      bannerMobileImage: bannerMobileImageportiagrande,
      textOverlay: "",
      data: {
        title: "VJ Portia Grande",
        subtitle: "Balewadi, Pune",
        starting_price: "₹ 4.3 Crore Onwards",
        payment_plan: "20:40:40",
        rerano: "P52100050636",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "VJ Portia Grande Balewadi Pune",
      description: [
        "VJ Portia Grande is an ultra-luxurious residential project by Vilas Javdekar Developers, located on the Baner-Balewadi Road in Pune. This under-construction development is designed for discerning homebuyers seeking expansive living spaces, modern architecture, and a premium lifestyle in one of Pune's most sought-after neighborhoods.",
        "Spread across approximately 1.21 acres, the project comprises two iconic towers rising up to 33 floors, offering a total of 132 meticulously crafted 4 and 4.5 BHK residences and duplexes. Each apartment is thoughtfully designed with spacious layouts, high ceilings, and large windows to ensure ample natural light and ventilation. The homes come equipped with smart home automation systems, best-in-class specifications, and three covered car parks per unit, catering to the needs of modern families.",
        "The project features two elegant towers rising above the skyline, encircled by the largest, most recognizable IT parks. Residents will enjoy premium amenities including a clubhouse with a steam room, swimming pool, gymnasium, and indoor games area. The location offers easy access to well-known work areas and commercial hubs.",
        "The strategic location of VJ Portia Grande provides excellent connectivity to key destinations including Pune International Airport (17.8 km), Vanaz Station (13.2 km), NICMAR University (4.1 km), Sanjivani Vitalife Hospital (3 km), and Regent Plaza Mall (4 km).",
      ],
      keywordLinks: {
      },
      image: overviewImageportiagrande,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconportiagrande,
          title: "₹ 4.3 Cr Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconportiagrande,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconportiagrande,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "2245 sq.ft.",
          price: "₹ 4.3 Cr",
          eoiAmount: "On Request",
        }
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "2245 sq.ft.",
        price: "₹ 4.3 Cr",
        image: floorplan1portiagrande,
      }
    ],

    highlights: {
      images: Hightlightsportiagrande,
      tagline: "Highlights",
      features: [
        "2 Elegant towers rising above the skyline",
        "Encircled by the largest, most recognizable IT parks",
        "Clubhouse for artists with a steam room",
        "Close to well-known work areas",
        "Smart home automation systems",
        "Three covered car parks per unit",
        "Premium lifestyle amenities",
      ],
    },

    location: {
      image: Locationportiagrande,
      data: [
        {
          airport: {
            distance_time: "17.8 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "4.1 km",
            name: "NICMAR University"
          },
          railwayormetro: {
            distance_time: "13.2 km",
            name: "Vanaz Station"
          },
          hospital: {
            distance_time: "3 km",
            name: "Sanjivani Vitalife Hospital"
          },
          mall: {
            distance_time: "4 km",
            name: "Regent Plaza Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1portiagrande },
        { image: gallery2portiagrande },
        { image: gallery3portiagrande },
        { image: gallery4portiagrande },
        { image: gallery5portiagrande },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in VJ Portia Grande, kindly share more details.",
    },

    faq: [
      {
        question: "Where is VJ Portia Grande located?",
        answer: "The project is situated on the Baner-Balewadi Road, near Jupiter Hospital.",
      },
      {
        question: "What configurations are available at VJ Portia Grande?",
        answer: "VJ Portia Grande offers 4 BHK and 4.5 BHK apartments.",
      },
      {
        question: "What is the RERA registration number of the project?",
        answer: "The project is registered under RERA with the number P52100050636.",
      },
      {
        question: "When is the expected possession date for VJ Portia Grande?",
        answer: "The possession of the apartments is expected by December 2027.",
      },
      {
        question: "What amenities are offered in VJ Portia Grande?",
        answer: "The project boasts a range of amenities, including a swimming pool, gymnasium, indoor games area, and clubhouse with steam room.",
      },
      {
        question: "How many towers and units are there in the project?",
        answer: "VJ Portia Grande comprises two elegant towers, each rising up to 33 storeys with a total of 132 units.",
      },
      {
        question: "What is the starting price of apartments in VJ Portia Grande?",
        answer: "The price of apartments in VJ Portia Grande starts from ₹4.3 crore onwards.",
      },
      {
        question: "What is the carpet area of the apartments?",
        answer: "The apartments have a carpet area of approximately 2,245 sq. ft.",
      },
      {
        question: "Who is the developer of VJ Portia Grande?",
        answer: "VJ Portia Grande is developed by Vilas Javdekar Developers.",
      },
      {
        question: "What is the address of VJ Portia Grande?",
        answer: "The project is located at S.No. 13, Plot No. 1C, Aundh-Baner Link Road, Pune.",
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", 
      to_email: "leads@gurugram-property.com",
    },
  },
  projecttwo: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecttwo,
      bannerMobileImage: bannerMobileImageprojecttwo,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojecttwo,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecttwo,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecttwo,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecttwo,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecttwo,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecttwo,
      }
    ],

    highlights: {
      images: Hightlightsprojecttwo,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecttwo,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecttwo },
        { image: gallery2projecttwo },
        { image: gallery3projecttwo },
        { image: gallery4projecttwo },
        { image: gallery5projecttwo },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "vilasjavdekar The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "vilasjavdekar The Trillion",
      description: [
        "vilasjavdekar The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by vilasjavdekar Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at vilasjavdekar Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at vilasjavdekar Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of vilasjavdekar The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "vilasjavdekar": "/developers/vilasjavdekar",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in vilasjavdekar The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is vilasjavdekar The Trillion located?",
        answer: `vilasjavdekar The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in vilasjavdekar The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at vilasjavdekar The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, vilasjavdekar The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of vilasjavdekar The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at vilasjavdekar The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of vilasjavdekar The Trillion?",
        answer: `vilasjavdekar The Trillion is developed by vilasjavdekar Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is vilasjavdekar The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, vilasjavdekar The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from vilasjavdekar The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
